<template>
  <section
    class="pricing section"
    :class="[
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]"
  >
  
    <div class="container">
      <div
        class="pricing-inner section-inner"
        :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <c-pricing-switcher
          v-if="pricingSwitcher"
          :state.sync="pricingSwitchOn"
          :labels="pricingSwitchLabels"
        />
        <div
          class="tiles-wrap illustration-section-03 reveal-from-top"
          :class="[pushLeft && 'push-left',]"
        >
          <div class="tiles-item reveal-from-top" data-reveal-delay="200">
            <div class="tiles-item-inner has-shadow">
              <div class="pricing-item-content">
                <div class="pricing-item-header center-content mb-24">
                  <div class="pricing-item-title text-xxs fw-500 pb-12">Essenstial</div>
                  <div class="pricing-item-price pt-24 pb-24">
                    <span class="pricing-item-price-currency text-color-high">$</span>
                    <span class="pricing-item-price-amount h1">{{pricingSwitchOn ? '29' : '35'}}</span>/m
                  </div>
                </div>
                <div class="pricing-item-features mb-40">
                  <div
                    class="pricing-item-features-title fw-500 text-xs text-color-high mb-24"
                  >Top features</div>
                  <ul class="pricing-item-features-list list-reset text-xs">
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li>Excepteur sint occaecat velit</li>
                    <li>Excepteur sint occaecat velit</li>
                  </ul>
                </div>
              </div>
              <div class="pricing-item-cta mb-16">
                <c-button tag="a" color="secondary" wide href="#">Free 14-day trial</c-button>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-from-top" data-reveal-delay="300">
            <div class="tiles-item-inner has-shadow">
              <div class="pricing-item-content">
                <div class="pricing-item-header center-content mb-24">
                  <div class="pricing-item-title text-xxs fw-500 pb-12">Business</div>
                  <div class="pricing-item-price pt-24 pb-24">
                    <span class="pricing-item-price-currency text-color-high">$</span>
                    <span class="pricing-item-price-amount h1">{{pricingSwitchOn ? '49' : '55'}}</span>/m
                  </div>
                </div>
                <div class="pricing-item-features mb-40">
                  <div
                    class="pricing-item-features-title fw-500 text-xs text-color-high mb-24"
                  >Top features</div>
                  <ul class="pricing-item-features-list list-reset text-xs">
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li>Excepteur sint occaecat velit</li>
                  </ul>
                </div>
              </div>
              <div class="pricing-item-cta mb-16">
                <c-button tag="a" color="primary" wide href="#">Free 14-day trial</c-button>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-from-top" data-reveal-delay="400">
            <div class="tiles-item-inner has-shadow">
              <div class="pricing-item-content">
                <div class="pricing-item-header center-content mb-24">
                  <div class="pricing-item-title text-xxs fw-500 pb-12">Enterprise</div>
                  <div class="pricing-item-price pt-24 pb-24">
                    <span class="pricing-item-price-currency text-color-high">$</span>
                    <span class="pricing-item-price-amount h1">{{pricingSwitchOn ? '89' : '95'}}</span>/m
                  </div>
                </div>
                <div class="pricing-item-features mb-40">
                  <div
                    class="pricing-item-features-title fw-500 text-xs text-color-high mb-24"
                  >Top features</div>
                  <ul class="pricing-item-features-list list-reset text-xs">
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                    <li class="is-checked">Excepteur sint occaecat velit</li>
                  </ul>
                </div>
              </div>
              <div class="pricing-item-cta mb-16">
                <c-button tag="a" color="secondary" wide href="#">Free 14-day trial</c-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CPricingSwitcher from "@/components/sections/partials/PricingSwitcher.vue";
import CButton from "@/components/elements/Button.vue";

export default {
  name: "CPricing",
  components: {
    CSectionHeader,
    CPricingSwitcher,
    CButton
  },
  mixins: [SectionTilesProps],
  props: {
    pricingSwitcher: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sectionHeader: {
        title: "Supreme template pricing",
        paragraph:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore aliqua."
      },
      pricingSwitchLabels: {
        type: "Billing Period", // screen-reader text
        default: "Billed Monthly",
        switchOn: "Billed Annually"
      },
      pricingSwitchOn: true
    };
  }
};
</script>